<template>
  <div id="app">
    <div v-if="loading" class="loading">
      <div class="logo">💎</div>
      <div class="title">加载成功</div>
      <div class="subtitle">您的内容已准备就绪</div>
      <button class="btn">前往访问</button>
      <div class="loading_line">
        <div class="progress" :style="{ '--progress': `${progress}%` }"></div>
      </div>
      <div class="progress_text">正在加载内容 {{ progress }}%</div>
    </div>

    <div v-else class="page" :style="{ '--bg': bg }">
      <div class="nav_bar">
        <div class="nav_bar_warp">
          问答验证
        </div>
      </div>
      <div class="main">
        <template v-for="(item, index) in question_ls">
          <div v-if="item.show" :key="index" class="chat_line">
            <img class="logo" :src="avatar" alt="" />
            <div class="chat_box">
              <p>{{ item.question }}</p>
              <div v-if="index" class="btn_line">
                <van-button class="btn" type="primary" size="small" :disabled="item.finished"
                  @click="on_click_btn(index)">
                  确定
                </van-button>
                <van-button class="btn" type="danger" size="small" :disabled="item.finished"
                  @click="on_click_btn(index)">
                  取消
                </van-button>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',

  data() {
    return {
      loading: false,
      progress: 0,
      timer: null,
      bg_img: '',
      avatar: '',
      jump_url: '',
      question_ls: [],
    }
  },

  computed: {
    bg() {
      if (this.bg_img) return `url(${this.bg_img})`
      else return '#ffffff'
    }
  },

  created() {
    this.get_questions()

    this.timer = setInterval(() => {
      this.progress++
      if (this.progress >= 100) {
        clearInterval(this.timer)
        this.timer = setTimeout(() => {
          this.loading = false
          clearTimeout(this.timer)
          this.timer = null
        }, 500)
      }
    }, 20)

    window.addEventListener('pagehide', (event) => {
      this.$toast.clear()
    });
  },

  methods: {
    get_questions() {
      this.$http({ url: '/api/landing/index' }).then(res => {
        const { code, data, msg } = res
        if (code !== 1) return this.$toast.fail(msg)
        this.bg_img = data.background_image
        this.avatar = data.avatar
        this.jump_url = data.redirect_url
        this.question_ls = data.questions.map((item, index) => {
          return {
            show: !index,
            finished: false,
            question: item.question,
          }
        })
        this.question_ls.unshift({
          show: true,
          question: '您好！为了保证服务质量，请回答一下几个问题：',
        })
      })
    },
    on_click_btn(i) {
      const question_qty = this.question_ls.length
      this.question_ls[i].finished = true

      if (i < question_qty - 1) this.question_ls[i + 1].show = true
      else {
        this.$toast.loading()
        location.href = this.jump_url
      }
    }
  }
}
</script>

<style lang="less" scoped>
#app {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  overflow: hidden;

  .loading {
    width: 100%;
    height: 100%;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .logo {
      width: 64px;
      aspect-ratio: 1/1;
      font-size: 32px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 50%;
      margin: 0 auto 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .title {
      font-size: 26px;
      font-weight: 700;
      margin-bottom: 10px;
    }

    .subtitle {
      font-size: 14px;
      opacity: 0.85;
      margin-bottom: 32px;
    }

    .btn {
      color: #667eea;
      font-size: 16px;
      font-weight: bold;
      letter-spacing: 0.5px;
      background: #fff;
      padding: 14px 44px;
      border: none;
      border-radius: 32px;
      cursor: pointer;
      transition: all 0.25s;
      box-shadow: 0 4px 18px rgba(0, 0, 0, 0.18);
    }

    .loading_line {
      width: 230px;
      max-width: 80vw;
      height: 5px;
      background: rgba(255, 255, 255, 0.22);
      margin-top: 22px;
      border-radius: 99px;
      overflow: hidden;

      .progress {
        width: var(--progress, 0%);
        height: 100%;
        background: linear-gradient(90deg, #fff 0%, #ffe4f1 100%);
        border-radius: 99px;
        transition: width .2s ease-out;
      }
    }

    .progress_text {
      color: rgba(255, 255, 255, 0.92);
      font-size: 13px;
      letter-spacing: 0.4px;
      padding-top: 8px;
    }
  }

  .page {
    width: 100%;
    max-width: 430px;
    height: 100%;
    margin: 0 auto;
    font-size: 14px;
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .nav_bar {
      width: 100%;
      height: 40px;
      background: var(--bg);
      background-size: 100% auto;
      background-repeat: no-repeat;

      .nav_bar_warp {
        width: 100%;
        height: 100%;
        background: #ffffff22;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .main {
      width: 100%;
      flex: 1;
      background: var(--bg, #ffffff);
      background-size: cover;
      background-repeat: no-repeat;
      padding: 10px;

      .chat_line {
        font-size: 13px;
        margin-bottom: 10px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;

        .logo {
          width: 50px;
          aspect-ratio: 1/1;
          border-radius: 50%;
        }

        .chat_box {
          background: #ffffff;
          padding: 10px;
          border-radius: 10px;
          margin-left: 10px;

          .btn_line {
            margin-top: 10px;
            display: flex;
            flex-wrap: nowrap;
            justify-content: center;
            align-items: center;
            gap: 10px;

            .btn {
              height: initial;
              font-size: 12px;
              font-weight: bold;
              padding: 4px 8px;
              border-radius: 4px;
              position: relative;
              overflow: hidden;
            }
          }
        }
      }
    }
  }
}
</style>
